import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './messages';
import dateTimeFormats from './dateTimeFormats';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'da',
  fallbackLocale: 'da',
  messages,
  dateTimeFormats,
});

export default i18n;
